"use strict";

function constant(_ref) {
  var opts = _ref.opts;
  var value = opts.value;
  return value;
}

module.exports = constant;